export const features = {
    install: (app: any) => {
        app.config.globalProperties.$features = window.features;
    },
};
